import { render, staticRenderFns } from "./InformGroupEditor.vue?vue&type=template&id=65409ef0&scoped=true"
import script from "./InformGroupEditor.vue?vue&type=script&lang=js"
export * from "./InformGroupEditor.vue?vue&type=script&lang=js"
import style0 from "./InformGroupEditor.vue?vue&type=style&index=0&id=65409ef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65409ef0",
  null
  
)

export default component.exports